function extractTextToHtml(initialValue) {
  const replaceText = initialValue.replace(/<[^>]*>?/g, '');
  return replaceText;
}

export default extractTextToHtml;
